import TrackingAbstract from './_trackingAbstract';
import _ from 'lodash';
export default class SegmentTracking extends TrackingAbstract {
    initProvider() {
        // Init for Segment is done in /src/index.tpl.html
    }
    identifyUser() {
        // User ID for Segment is done elsewhere.
    }
    unidentifyUser() {
        if (!this.checkSegment()) {
            return;
        }
        this.$window.analytics.reset();
    }
    track(eventName, properties, context) {
        this.$log.debug(`segment:${eventName}`, properties);
        if (!this.checkSegment()) {
            return;
        }
        const isFromPretender = window.navigator.userAgent.includes('Prerender');
        if (isFromPretender) {
            return;
        }
        this.$q
            .all([this.institutionHelper.getCurrentInstitution()])
            .then(([institution]) => {
            const clinicId = _.get(institution, 'id', null);
            const userType = this.getUserType();
            this.$window.analytics.track(eventName, {
                user_type: userType,
                user_id: _.get(this.currentUserHelper, 'user.id', null),
                plan_type: this.currentUserHelper.getPlanName() || null,
                clinic_id: clinicId,
                ...properties,
            }, {
                ...(Boolean(this.currentUserHelper.user?.id) && {
                    anonymousId: String(this.currentUserHelper.user.id),
                }),
                group_id: clinicId,
                ...this.platformData,
                ...context,
                // eslint-disable-next-line promise/always-return
                ...(userType === 'patient' && { ip: '0.0.0.0' }),
            });
        })
            .catch((error) => console.error(error));
    }
    trackWithoutParams(eventName, context) {
        if (!this.checkSegment()) {
            return;
        }
        this.$window.analytics.track(eventName, undefined, {
            ...context,
            ...this.platformData,
            ...(Boolean(this.currentUserHelper.user?.id) && {
                anonymousId: String(this.currentUserHelper.user.id),
            }),
        });
    }
    trackWithExplicitProperties(eventName, properties) {
        if (!this.checkSegment()) {
            return;
        }
        this.$window.analytics.track(eventName, { ...properties }, {
            ...(Boolean(this.currentUserHelper.user?.id) && {
                anonymousId: String(this.currentUserHelper.user.id),
            }),
        });
    }
    trackPageView() {
        return; // The call which triggered this, in `global.router.js`, was commented-out when this was refactored.
        if (!this.checkSegment()) {
            return;
        }
        this.$window.analytics.page({}, {
            ...(Boolean(this.currentUserHelper.user?.id) && {
                anonymousId: String(this.currentUserHelper.user.id),
            }),
        });
    }
    trackScreenshare(phase, data = {}) {
        if (!this.checkSegment()) {
            return;
        }
        const sessionId = _.get(this.VideoProviderFactory, 'activeProvider.callSession.id');
        // In some cases (like patient tab closed) sessionId becomes null
        // so here it is being saved at start phase for backup
        let savedSessionId = sessionId;
        this.track(`Screenshare ${phase}`, {
            user_type: this.getUserType(),
            room_id: _.get(this.roomHelpersFactory.getRoom(), 'id', null),
            plan_type: this.currentUserHelper.getPlanName() || null,
            user_id: Boolean(this.currentUserHelper.user)
                ? this.currentUserHelper.user.id
                : null,
            session_id: sessionId || savedSessionId || null,
            ...data,
        }, {
            ...(Boolean(this.currentUserHelper.user?.id) && {
                anonymousId: String(this.currentUserHelper.user.id),
            }),
        });
        if (phase === 'Ended') {
            setTimeout(() => {
                savedSessionId = null;
            }, 500);
        }
    }
    // ===========================================================================
    // Private functions
    // ===========================================================================
    checkSegment() {
        if (!this.$window.analytics ||
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions
            !this.$window.analytics.user ||
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions
            !this.$window.analytics.user().anonymousId) {
            console.info('Segment analytics not loaded');
            return false;
        }
        return true;
    }
}
